
// src/services/produitsAdmin.js  (ou fusionne dans ton fichier produits existant)
import { get, put } from '../../services/api';

export const getAllProduits = async () => {
  const res = await get('/produits');
  return res.data;
};

export const validerProduit = async (id) => {
  await put(`/produits/${id}/valider`);
};

export const rejeterProduit = async (id) => {
  await put(`/produits/${id}/rejeter`);
};

export const getProduitsValidesAvecVendeur = async () => {
  const res = await get('/produits/valides-avec-vendeur');
  return res.data;
};

export const getProduitsEnAttenteAvecVendeur = async () => {
  const res = await get('/produits/en-attente-avec-vendeur');
  return res.data;
};

export const fetchProduitsValides = async () => {
  const res = await get('/produits/valides-avec-vendeur');
  return res.data;
};
